<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "App",
  created() {
    this.$axios = this.axiosClient;
    this.$store.dispatch('initApp', {});
  },
  methods: {
    ...mapGetters({
      axiosClient: 'getAxios',
    }),
  }
}
</script>